const handleUpdateFormDetailsOutside = (callback) => {
  const sideBarElem = document.querySelector(".home-upload-sidebar");
  if (sideBarElem?.classList.contains("collapsed")) {
    document.querySelector(".collapse-button")?.click();
  }
  setTimeout(() => {
    sideBarElem.querySelector(".submit-form-button")?.click();
  }, 100);
  callback && callback();
};

export default handleUpdateFormDetailsOutside;
